import React, { useEffect, useState, useCallback } from 'react'
import JobCard from 'Components/JobCard'

import * as api from 'API/api';
import { completeAppointment, noShowAppointment, partsRequiredAppointment } from 'API';
import { useDateQueryParam } from 'hooks/useDateQueryParams';

import CreateAppointmentModal from 'Components/Appointments/CreateAppointmentModal'
import DisplayOwnerModal from 'Components/Appointments/DisplayOwnerModal'
import AddVinModal from 'Components/Appointments/AddVinModal';

const Appointment = () => {
    const [appointmentData, setAppointmentData] = useState([]);
    const [selectedDate, setSelectedDate] = useDateQueryParam("date");

    const [serviceData, setServiceData] = useState([]);

    // Modal Controller 
    const [openCreate, setOpenCreate] = useState(false);
    const [openOwner, setOpenOwner] = useState(false);
    const [openAddVin, setOpenAddVin] = useState(false);

    const [ownerModalData, setOwnerModalData] = useState({});
    const [vehicleModalData, setVehicleModalData] = useState({});


    // SOrting the appointment with time 
    const sortByStartTime = (list) => {
        return [...list].sort(
            (a, b) =>
                new Date(a.start.replace(" ", "T")) -
                new Date(b.start.replace(" ", "T"))
        );
    };

    const getAppointments = useCallback(async () => {
        try {
            const response = await api.fetchAppointments(selectedDate);
            const appointments = response ?? [];
            const sorted = sortByStartTime(appointments);

            setAppointmentData(sorted);
            console.log("Fetched Appointments:", appointments);
        } catch (error) {
            console.error("Failed to fetch appointments:", error);
            setAppointmentData([]);
        }
    }, [selectedDate]);

    useEffect(() => {
        const loadServices = async () => {
            const services = await api.fetchServices();
            setServiceData(services);
        };

        loadServices();
    }, []);

    const handleJobCompletion = async (appointmentId) => {
        const response = await completeAppointment(appointmentId);
        if (!response) return;
        await getAppointments();
    }

    const handleJobNoShow = async (appointmentId) => {
        const response = await noShowAppointment(appointmentId);
        if (!response) return;
        await getAppointments();
    }

    const handleJobPartsRequired = async (appointmentId) => {
        const response = await partsRequiredAppointment(appointmentId);
        if (!response) return;
        await getAppointments();
    }

    useEffect(() => {
        if (!selectedDate) return;
        getAppointments();
    }, [selectedDate, getAppointments]);



    return (
        <>
            <div className="flex items-center justify-between border-b border-gray-300 pb-2 p-3">
                <h1 className="text-left text-2xl font-semibold">
                    Appointments
                </h1>

                <div className="flex items-center gap-3 mr-20">
                    <input
                        value={selectedDate}
                        onChange={(e) => {
                            setSelectedDate(e.target.value);
                        }}
                        type="date"
                        className="rounded-md border border-gray-300 px-2 py-2 text-sm outline-none focus:border-gray-400"
                    />

                    <button onClick={() => setOpenCreate(true)} className="rounded-md bg-black px-3 py-2 text-sm text-white">
                        + Create Appointment
                    </button>
                </div>
            </div>

            {/* Timeline div */}
            {/* <div className="mt-2 flex w-full justify-evenly flex-col gap-4 lg:flex-row">
                <Timeline slotsMap={availableSlots} />
            </div> */}
            <div className=' text-left font-semibold mt-6 mb-4 px-3' >
                <h2> Jobs for the day.</h2>

            </div>

            <div className="flex w-full flex-wrap gap-4 px-3">
                {appointmentData && appointmentData.length > 0 ? (
                    appointmentData.map((job, index) => (
                        <JobCard key={index} data={job} completeJob={handleJobCompletion}
                            noShowAppointment={handleJobNoShow}
                            partsRequiredAppointment={handleJobPartsRequired}
                            setOwnerModalData={setOwnerModalData}
                            setVehicleModalData={setVehicleModalData}
                            viewOwner={() => { setOpenOwner(true) }}
                            setVin={(vehicle) => {
                                setVehicleModalData(vehicle);
                                setOpenAddVin(true);
                            }} />
                    ))
                ) : (
                    <p className="text-gray-500">No appointments for this date</p>
                )}
            </div>


            {/* Modal to Create Appointment  */}
            <CreateAppointmentModal
                open={openCreate}
                onClose={() => setOpenCreate(false)}
                date={selectedDate}
                services={serviceData}
                onCreate={(data) => {
                    console.log("Created Appointment:", data);
                }}
            />

            {/* Modal to display Contact */}
            <DisplayOwnerModal
                open={openOwner}
                onClose={() => setOpenOwner(false)}
                client={ownerModalData}

            />

            {/* Modal to update VIN     */}
            <AddVinModal
                open={openAddVin}
                onClose={() => setOpenAddVin(false)}
                vehicle={vehicleModalData}
            />





        </>
    )
}

export default Appointment;